import React from 'react';
import axios from 'axios';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import {
  Save, Radio, RefreshCw, CheckCircle, AlertCircle, Download
} from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const TelegramConfigSection = ({
  config, setConfig, saving, testing, reregistering, recovering,
  testResult, webhookInfo, onSave, onTest, onReregister, onRecover
}) => (
  <div className="bg-[#121212] border border-[#27272A] p-6 mb-6">
    <div className="flex items-center gap-3 mb-6">
      <Radio className="w-6 h-6 text-[#E3000F]" />
      <h2 className="text-xl font-semibold uppercase" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
        Telegram Bot
      </h2>
    </div>

    <div className="space-y-5">
      <div>
        <label className="form-label">Bot Token</label>
        <Input
          type="password"
          value={config.bot_token}
          onChange={(e) => setConfig({ ...config, bot_token: e.target.value })}
          className="bg-[#0A0A0A] border-[#27272A] rounded-none text-white"
          placeholder="Token del bot"
          data-testid="input-bot-token"
        />
      </div>
      <div>
        <label className="form-label">ID Canale</label>
        <Input
          value={config.channel_id}
          onChange={(e) => setConfig({ ...config, channel_id: e.target.value })}
          className="bg-[#0A0A0A] border-[#27272A] rounded-none text-white"
          placeholder="-1001234567890"
          data-testid="input-channel-id"
        />
      </div>

      <div className="flex flex-wrap gap-3">
        <Button onClick={onSave} disabled={saving} className="bg-[#E3000F] hover:bg-[#CC000D] text-white rounded-none uppercase tracking-wide" data-testid="save-telegram-config-btn">
          <Save className="w-4 h-4 mr-2" />
          {saving ? 'Salvataggio...' : 'Salva'}
        </Button>
        <Button onClick={onTest} disabled={testing} className="bg-[#1A1A1A] border border-[#333333] hover:border-[#E3000F] text-white rounded-none uppercase tracking-wide" data-testid="test-telegram-btn">
          <Radio className="w-4 h-4 mr-2" />
          {testing ? 'Test...' : 'Test Connessione'}
        </Button>
        <Button onClick={onReregister} disabled={reregistering} className="bg-[#1A1A1A] border border-[#333333] hover:border-[#FFC107] text-white rounded-none uppercase tracking-wide" data-testid="reregister-webhook-btn">
          <RefreshCw className={`w-4 h-4 mr-2 ${reregistering ? 'animate-spin' : ''}`} />
          {reregistering ? 'Aggiornamento...' : 'Aggiorna Webhook'}
        </Button>
        <Button onClick={onRecover} disabled={recovering} className="bg-[#1A1A1A] border border-[#333333] hover:border-[#009246] text-white rounded-none uppercase tracking-wide" data-testid="recover-messages-btn">
          <Download className={`w-4 h-4 mr-2 ${recovering ? 'animate-spin' : ''}`} />
          {recovering ? 'Recupero in corso...' : 'Recupera messaggi persi'}
        </Button>
      </div>

      {testResult && (
        <div className="bg-[#009246]/10 border border-[#009246]/30 p-4">
          <div className="flex items-center gap-3">
            <CheckCircle className="w-5 h-5 text-[#009246]" />
            <p className="text-[#A1A1AA] text-sm">
              Bot: <strong className="text-white">{testResult.bot_name}</strong> (@{testResult.bot_username})
            </p>
          </div>
        </div>
      )}

      {webhookInfo && (
        <div className={`border p-3 flex items-center gap-2 ${webhookInfo.ok ? 'bg-[#009246]/10 border-[#009246]/30' : 'bg-[#FFC107]/10 border-[#FFC107]/30'}`}>
          {webhookInfo.ok ? (
            <CheckCircle className="w-4 h-4 text-[#009246] flex-shrink-0" />
          ) : (
            <AlertCircle className="w-4 h-4 text-[#FFC107] flex-shrink-0" />
          )}
          <code className="text-sm text-[#A1A1AA] break-all">{webhookInfo.url}</code>
        </div>
      )}
    </div>
  </div>
);
